export { FileInfoPopup } from './file-info-popup';
export type { FileInfoPopupProps } from './file-info-popup';
